import { render, staticRenderFns } from "./list_gcjs.vue?vue&type=template&id=77192676&scoped=true"
import script from "./list_gcjs.vue?vue&type=script&lang=js"
export * from "./list_gcjs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77192676",
  null
  
)

export default component.exports